import immutableStore from 'utils/immutableStore';
import alt from 'components/Dispatcher';
import TriggerRuleActions from 'actions/triggers/TriggerRuleActions';
import {List, Map, Record} from 'immutable';

@immutableStore
class TriggerRuleStore {
  constructor() {
    this.state = Record({
      rules: Map(),
      rulesLoading: true,
      rulesErrored: false,
      rulePermissions: Map(),
      rulePermissionsLoading: Map(),
      rulePermissionsErrored: Map(),
      antiRules: Map(),
      antiRulesLoading: Map(),
      antiRulesErrored: Map(),
      saving: false,
      stagedPermissions: undefined,
    })();
    this.bindActions(TriggerRuleActions);
  }

  onClearStagedPermissions() {
    this.setState({
      stagedPermissions: undefined,
    });
  }

  createTriggerRuleSuccess(rule) {
    const {rules} = this.state;
    this.setState({
      rules: rules.set(rule.id.toString(), rule),
    });
  }

  createTriggerRuleError(error) {
    console.error(error);
  }

  fetchTriggerRules() {
    this.setState({
      rules: Map(),
      rulesLoading: true,
      rulesErrored: false,
    });
  }

  fetchTriggerRulesSuccess(rules) {
    this.setState({
      rulesLoading: false,
      rules,
    });
  }

  fetchTriggerRulesError(response) {
    console.error(response);
    this.setState({
      rulesLoading: false,
      rulesErrored: true,
    });
  }

  fetchTriggerRulePermissions(ruleId) {
    this.setState({
      rulePermissions: this.state.rulePermissions.set(ruleId, null),
      rulePermissionsLoading: this.state.rulePermissionsLoading.set(ruleId, true),
      rulePermissionsErrored: this.state.rulePermissionsErrored.set(ruleId, false),
    });
  }

  fetchTriggerRulePermissionsSuccess([ruleId, permissions]) {
    this.setState({
      rulePermissions: this.state.rulePermissions.set(ruleId, permissions),
      rulePermissionsLoading: this.state.rulePermissionsLoading.set(ruleId, false),
    });
  }

  fetchTriggerRulePermissionsError(ruleId) {
    this.setState({
      rulePermissionsLoading: this.state.rulePermissionsLoading.set(ruleId, false),
      rulePermissionsErrored: this.state.rulePermissionsErrored.set(ruleId, true),
    });
  }

  fetchTriggerRuleSuccess(rule) {
    const {rules} = this.state;
    this.setState({
      rules: rules.set(rule.id.toString(), rule),
    });
  }

  updateTriggerRuleSuccess(rule) {
    const {rules} = this.state;
    this.setState({
      rules: rules.set(rule.id.toString(), rule),
    });
  }

  removeTriggerRuleSuccess(ruleId) {
    this.setState({
      rules: this.state.rules.remove(ruleId.toString()),
    });
  }

  removeTriggerRuleError(resp) {
    console.error(resp);
  }

  fetchTriggerRuleActionsSuccess([ruleId, results]) {
    const {rules} = this.state;
    const rule = rules.get(ruleId.toString());
    const newRule = rule.set('actions', results);
    this.setState({
      rules: rules.set(ruleId.toString(), newRule),
    });
  }

  fetchTriggerRuleActionsError(response) {
    console.error(response);
  }

  fetchTriggerTrendsSuccess([ruleId, results]) {
    const {rules} = this.state;
    const rule = rules.get(ruleId.toString());
    const newRule = rule.set('trends', results);
    this.setState({
      rules: rules.set(ruleId.toString(), newRule),
    });
  }

  fetchTriggerTrendsError(response) {
    console.error(response);
  }

  updateTriggerTrendSuccess(trend) {
    const {rules} = this.state;
    const trendId = trend.id.toString();
    const ruleId = trend.ruleId.toString();
    const rule = rules.get(ruleId);
    const newTrends = rule.trends.set(trendId.toString(), trend);
    const newRule = rule.set('trends', newTrends);
    this.setState({
      rules: rules.set(ruleId, newRule),
    });
  }

  createTriggerRuleActionSuccess(result) {
    const {rules} = this.state;
    if (result.trendId) {
      // This is a trend action nothing to do for now
    } else if (result.ruleId) {
      const rule = rules.get(result.ruleId.toString());
      const newActions = rule.actions.set(result.id.toString(), result);
      const newRule = rule.set('actions', newActions);
      this.setState({
        rules: rules.set(rule.id.toString(), newRule),
        saving: false,
      });
    }
  }

  createTriggerRuleActionError(response) {
    console.error(response);
    this.setState({
      saving: false,
    });
  }

  onCreateTriggerRuleAction() {
    this.setState({
      saving: true,
    });
  }

  onUpdateTriggerRuleAction([ruleId, actionId, triggerRuleAction]) {
    const {rules} = this.state;
    const rule = rules.get(ruleId.toString());
    const newActions = rule.actions.set(actionId.toString(), triggerRuleAction);
    const newRule = rule.set('actions', newActions);
    this.setState({
      rules: rules.set(ruleId.toString(), newRule),
      saving: false,
    });
  }

  createTriggerTrendSuccess(triggerTrend) {
    const {rules} = this.state;
    const ruleId = triggerTrend.ruleId.toString();
    const rule = rules.get(ruleId);
    const newTrends = rule.trends.set(triggerTrend.id.toString(), triggerTrend);
    const newRule = rule.set('trends', newTrends);
    this.setState({
      rules: rules.set(ruleId, newRule),
    });
  }

  fetchAntiRules(ruleId) {
    this.setState({
      antiRules: this.state.antiRules.set(ruleId, List()),
      antiRulesLoading: this.state.antiRulesLoading.set(ruleId, true),
      antiRulesErrored: this.state.antiRulesErrored.set(ruleId, false),
    });
  }

  fetchAntiRulesSuccess([ruleId, antiRules]) {
    this.setState({
      antiRules: this.state.rulePermissions.set(ruleId, antiRules),
      antiRulesLoading: this.state.antiRulesLoading.set(ruleId, false),
    });
  }

  fetchAntiRulesError(ruleId) {
    this.setState({
      antiRulesLoading: this.state.antiRulesLoading.set(ruleId, false),
      antiRulesErrored: this.state.antiRulesErrored.set(ruleId, true),
    });
  }

  fetchTriggerRuleTagsSuccess([ruleId, tags]) {
    const {rules} = this.state;
    const rule = rules.get(ruleId.toString());
    if (rule) {
      const newRule = rule.set('tags', tags);
      this.setState({
        rules: rules.set(ruleId.toString(), newRule),
      });
    }
  }

  fetchTriggerRuleTagsError([ruleId, error]) {
    console.error(error);
  }

  updateTriggerRuleTagsSuccess(ruleId, tags) {
    const {rules} = this.state;
    const rule = rules.get(ruleId.toString());
    if (rule) {
      const newRule = rule.set('tags', tags);
      this.setState({
        rules: rules.set(ruleId.toString(), newRule),
      });
    }
  }

  updateTriggerRuleTagsError(ruleId, error) {
    console.error(error);
  }

  updateTriggerNameSuccess(rule) {
    const {rules} = this.state;
    const ruleId = rule.id.toString();
    const existingRule = rules.get(ruleId);
    // Server doesn't send tags in its response, but they don't change as a result of renaming. Copy from old version
    // of the rule.
    rule = rule.set('tags', existingRule.get('tags'));
    this.setState({
      rules: rules.set(ruleId, rule),
    });
  }

  updateTriggerNameError(error) {
    console.error(error);
  }
}

export default alt.createStore(TriggerRuleStore, 'TriggerRuleStore');
